import { Input, TextField, Typography, FormControl, FormHelperText, Autocomplete,
    Select, MenuItem, FormControlLabel, Checkbox, Avatar, Button, InputLabel } from '@mui/material';
import dayjs from '../../utils/dayjs-setup';
import { alpha, styled } from '@mui/material/styles';
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import NotFileImage from "../../assets/images/no_file.png";
import {UploadFile} from "@mui/icons-material";
import { useUploadFile } from "../../hooks/useUploadFile";
import { useRef } from "react";
import { DateFormatString, DateTimeFormatString } from "../../utils/constants";

export const InputFile = ({label='',type='text',register=()=>({}),keyValue,errorMessage="",...props})=> {


    const {
        image_url,
        setImageUrl,
        clickUploadFile,
        InputFileRaw
    } = useUploadFile({
        default_value:props.value,
        keyValue,
        code_entity_save:props.code_entity_save,
        setImageValue:props.onChange
      
    });

    return <FormControl fullWidth sx={{marginTop:'10px',alignItems:"center"}} error={errorMessage?true:false} >



    <Avatar sx={{width:100,height:100,marginBottom:'10px'}} src={ image_url? `${import.meta.env.VITE_AWS_STORAGE}/${image_url}` : NotFileImage}   variant="square" />
    <Button  size="small" onClick={clickUploadFile} variant="contained" startIcon={<UploadFile />}>
      {label}
    </Button>
    <InputFileRaw />
    {
   
   errorMessage && <FormHelperText error={true} >
       {errorMessage}
   </FormHelperText>
}
    </FormControl>
}


export const InputWithLabel = ({label='',type='text',register=()=>({}),keyValue,errorMessage="",endAdornment,customHelper,inputType,...props})=> (
<TextField
  fullWidth
  size="small"
  variant="outlined"
  label={label}
  type={inputType || type}
  error={Boolean(errorMessage)}
  helperText={errorMessage || customHelper || undefined}
  sx={{marginTop:'10px'}}
  {...register(keyValue)}
  slotProps={endAdornment ? { input: { endAdornment } } : undefined}
  {...props}
/>
)

export const CheckBoxWithLabel = ({label,type='text',register=()=>({}),keyValue,errorMessage="",value,...props})=> <FormControl fullWidth sx={{marginTop:'10px'}} error={errorMessage?true:false} >
 <FormControlLabel control={<Checkbox checked={value} />} label={label}  {...register(keyValue)}  error={errorMessage?true:false}   type={type} fullWidth {...props}  />


{
    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
</FormControl>

export const SelectInputWithLabel = ({label,register=()=>({}),type='',keyValue,errorMessage="",items=[],...props})=> <FormControl fullWidth size="small" sx={{marginTop:'10px'}} error={errorMessage?true:false} >
<InputLabel>{label}</InputLabel>
<Select label={label} {...register(keyValue)}  error={errorMessage?true:false}   type={type} fullWidth {...props} >
{
     
    items.map( item=><MenuItem

    key={item.value}
    value={item.value}
    >
        {item.label}
    </MenuItem> )
}
</Select>
{
    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
</FormControl>

export const AutoCompleteInputWithLabel = ({label,register=()=>({}),type='',keyValue,errorMessage="",items=[],...props})=>(
    <FormControl  fullWidth sx={{marginTop:'10px'}} error={errorMessage?true:false} >
<Autocomplete 
autoComplete='off'
  {...register(keyValue)} 
  error={errorMessage?true:false}

  {...props}
  onChange={(evt,value)=> props.onChange && props.onChange(value) }
  renderInput={(params) => (
    <TextField autoComplete="off"  {...params} fullWidth size="small" label={label} />
  )}
/>
{
    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
    </FormControl>
)

export const AutoCompleteInputImagenWithLabel = ({label,register=()=>({}),type='',keyValue,errorMessage="",items=[],...props})=>(
    <FormControl fullWidth sx={{marginTop:'10px'}} error={errorMessage?true:false} >
<Typography variant="body1" >{label}</Typography>
<Autocomplete 
  {...register(keyValue)} 
  error={errorMessage?true:false}
  
  {...props}
  onChange={(evt,value)=> props.onChange && props.onChange(value) }
  renderInput={(params) => (
    <TextField   {...params} fullWidth />
  )}
/>
{
    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
    </FormControl>
)

export const DatePickerInputWithLabel = ({ label, register = () => ({}), type = '', keyValue, errorMessage = "", items = [],inputProps, ...props }) => (
    <FormControl size="small" fullWidth sx={{ marginTop: '10px' }} error={errorMessage ? true : false} >
        <DatePicker
            
            {...register(keyValue)}
            error={errorMessage ? true : false}
            {...props}
            value={props.value ? dayjs(props.value) : null}

            onChange={(value)=>props.onChange(value ? dayjs(value).format(DateFormatString) : null)}
            slotProps={{ textField: { size: 'small', fullWidth: true, label, ...inputProps } }}
        />
{     

    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
    </FormControl>)

export const DateTimePickerInputWithLabel = ({ label, register = () => ({}), type = '', keyValue, errorMessage = "", items = [],inputProps, ...props }) => (
    <FormControl size="small" fullWidth sx={{ marginTop: '10px' }} error={errorMessage ? true : false} >
        <Typography variant="body1" >{label}</Typography>
        <DateTimePicker
            {...register(keyValue)}
            error={errorMessage ? true : false}
            {...props}
            value={props.value ? dayjs(props.value) : null}

            onChange={(value)=>props.onChange(value ? dayjs(value).format(DateTimeFormatString) : null)}
            slotProps={{ textField: { ...props, ...inputProps } }}
        />
{     

    errorMessage && <FormHelperText error={true} >
        {errorMessage}
    </FormHelperText>
}
    </FormControl>)


export const CustomAutoComplete = styled(Autocomplete)(({ theme }) => ({
    "& .MuiFormLabel-root":{
     color: theme.palette.text.primary,
     fontSize:"1.2rem"
    }
 
 }));